import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NavigationService implements OnDestroy {
    subscription: Subscription;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        this._previousUrl.push(this.router.url);

        this.subscription = router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe((e: NavigationEnd) => this.addLink(e.url));
    }

    private _previousUrl: string[] = [];

    get previousUrl(): string {
        return this._previousUrl[this._previousUrl.length - 2];
    }

    get isFirstLoaded(): boolean {
        return !this.previousUrl;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    addLink(url: string) {
        if (this._previousUrl.length > 2) {
            this._previousUrl.shift();
        }
        this._previousUrl.push(url);
    }
}
